import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-rules-en',
  imports: [],
  templateUrl: './rules-en.component.html',
  styleUrl: './rules-en.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RulesEnComponent {
  scrollToSection(event: Event, sectionId: string): void {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
